import type { CentrifugeMessage } from '@module/types/centrifuge/messageTypes';
import type { MessageDispatcher, MessageHandler, MessageHandlerContext } from './types';

/**
 * 메시지 디스패처 구현
 * 등록된 핸들러들에게 메시지를 전달하고 처리를 위임
 */
export class DefaultMessageDispatcher implements MessageDispatcher {
  private handlers: MessageHandler[] = [];

  register(handler: MessageHandler): void {
    this.handlers.push(handler);
  }

  async dispatch(payload: CentrifugeMessage, context: MessageHandlerContext): Promise<void> {
    for (const handler of this.handlers) {
      if (handler.canHandle(payload)) {
        await handler.handle(payload, context);
      }
    }
  }
}
